
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { addProductAccount } from '@/api/product/productAccount'
import { Form as ElForm } from 'element-ui'
import { addItem, removeItem } from '@/utils/arrays'
import { isTimeRange } from '@/utils/validate'
// import { productAccountBasicRules } from '@/utils/rules'
import editAccountConfig from './editAccountConfig.vue'
import editAccountLimitation from './editAccountLimitation.vue'
import {
  setProductAccount,
  getProductAccount
} from '@/api/product/productAccount'
import { getProductAccountList } from '@/api/product/productAccount'
import { getAccountGroupList } from '@/api/product/accountGroup'

@Component({
  name: 'addAccount',
  components: {
    editAccountConfig,
    editAccountLimitation
  }
})
export default class extends Vue {
  @Prop({ required: true }) product!: any
  @Prop({ required: true }) id!: string | number

  private accountType: any = this.product
  private steps = 1
  private account: any = {}
  private currentAccount: any = {}
  private infoForm: any = {
    account_no: '',
    account_name: '',
    account_type: '',
    status: '1',
    product_account_group: [],
    remarks: ''
  }
  private productAccountBasicRules: any = {
    account_name: [
      {
        required: true,
        message: 'Please enter the Account Name',
        trigger: 'blur'
      }
    ],
    account_no: [
      {
        required: true,
        message: 'Please enter the Account No',
        trigger: 'blur'
      }
      // { pattern: /^\w+$/, message: 'Please enter letters, numbers or underscores', trigger: 'change' }
    ],
    account_type: [
      { required: true, message: 'Please select Account Type', trigger: 'blur' }
    ],
    status: [
      { required: true, message: 'Please select status', trigger: 'blur' }
    ],
    description: [
      { required: true, message: 'Please input description', trigger: 'blur' }
    ]
  }
  private loading = false
  // private rules = productAccountBasicRules
  private productAccountList: any = []

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  mounted() {
    if (this.product.product === 4) {
      this.product.product = 3
    }
  }

  // 监听当前创建的产品
  @Watch('product.name', { immediate: true })
  private productChange() {
    this.infoForm.product = this.product.id
    // this.getProductAccountList()
    this.getAccountGroupList()
  }

  // 获取账户组列表
  private async getAccountGroupList() {
    const params = {
      product: this.infoForm.product
    }
    await getAccountGroupList(params).then((res: any) => {
      this.productAccountList = res.results
    })
  }

  private next() {
    this.steps++
    if (this.steps === 4) {
      this.back()
    }
  }

  private back() {
    this.$emit('close')
  }

  private create() {
    ;(this.$refs.infoForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.loading = true
          this.flag = true
          const data = {
            ...this.infoForm,
            product: this.product.id
          }
          if (!data.status) {
            data.status = 1
          }
          if (!data.remarks) {
            delete data.remarks
          }
          await addProductAccount(data).then((res: any) => {
            this.$message({
              message: 'Create successful!',
              type: 'success'
            })
            this.loading = false
            this.account = res
            this.flagStr()
            this.next()
          })
        } catch (e) {
          this.loading = false
          this.flagStr()
        }
      } else {
        return false
      }
    })
  }

  private async getProductAccount() {
    if (this.id === null) {
      await getProductAccount(this.id).then((res: any) => {
        this.currentAccount = res
      })
    }
  }

  created() {
    this.getProductAccount()
  }
}
